import { Component, Injectable, ModuleWithComponentFactories, NgModule, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Eleicao } from 'src/app/models/eleicao.model';
import { Gestor } from 'src/app/models/gestor.model';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { HttpClientModule} from '@angular/common/http';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ModalComprovanteZeresimaComponent } from '../modals/comprovante-zeresima/modal-comprovante-zeresima.component';
import * as moment from 'moment';
import { format } from 'url';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatDate, Location } from '@angular/common';
import { Router } from '@angular/router';
import { StatusEleicao } from 'src/app/models/enums/status-eleicao-enum';
import { Utils } from 'src/app/utils/utils';
import { environment } from '../../../../environments/environment';

declare var window: any;

@Component({
  selector: 'app-cadastro-eleicao',
  templateUrl: './cadastro-eleicao.component.html',
  styleUrls: ['./cadastro-eleicao.component.css']
})

@Injectable()
export class CadastroEleicaoComponent implements OnInit {
  generalMaskDate = "00/00/0000";
  eleicao = new Eleicao();
  logo: any;
  formGroup: FormGroup;
  token: string;
  isSubmit: boolean = false;
  resposta: any;
  idGestor: number = +sessionStorage.getItem('idGestor');
  rota: any;
  msgmData: any;
  editandoEleicao: boolean;
  eleicaoParametrizacao: any;
  editavelDataFim: string;
  editavelDataInicio: string;
  btOff: boolean = false;
  link: any;
  formModal: any;

  constructor(
    protected messageService: MessageService,
    protected eleicaoService: EleicaoService,
    protected formBuilder: FormBuilder,
    public spinner: NgxSpinnerService,
    private location: Location,
    public utils: Utils,
    private router: Router
    
    ) { }

  ngOnInit() {
    this.link = environment.url_front;
    this.formGroup = new FormGroup({
      titulo: new FormControl(),
      instrucao: new FormControl(),
      termo: new FormControl(),
      mensagem: new FormControl(),
      dataHoraInicio: new FormControl(),
      dataHoraFim: new FormControl(),
      labelAuth1: new FormControl(),
      labelAuth2: new FormControl(),
      placeHolderLogin: new FormControl(),
      logo: new FormControl(),
      acessoIntegracao: new FormControl(),
      enviaEmails: new FormControl(),
      rastreabilidade: new FormControl(),
      temCandidaturas: new FormControl(),
      temPlanos: new FormControl(),
      cnpj: new FormControl(),
    })
    
    this.formGroup = this.formBuilder.group({
      titulo: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      instrucao: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      termo: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      mensagem: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      dataHoraInicio: ['', Validators.required],
      dataHoraFim: ['', Validators.required],
      labelAuth1: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      labelAuth2: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      placeHolderLogin:[''], 
      logo: [''],
      acessoIntegracao: [''],
      enviaEmails: [''],
      rastreabilidade: [''],
      temCandidaturas: [''],
      cnpj: [''],
      temVotoEmBranco: [true],
      temVotoNulo: [true],
      temCancelarVoto: [true],
      temPlanos: ['']
    });
    this.formModal = new window.bootstrap.Modal(
      document.getElementById('myModal')
    );
    if(this.router.url == '/gestor/configuracoes'){
      this.editandoEleicao = true;
    } else {
      this.editandoEleicao = false;
      this.formGroup.patchValue({labelAuth1: "Autenticação 1", labelAuth2: "Autenticação 2"});
    }
    // para edição | Atribuindo valores da eleição escolhida para ser editada e formatando datas para exibição nos inputs
    this.eleicaoParametrizacao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    if(this.editandoEleicao == true){
      this.editavelDataFim = formatDate(this.eleicaoParametrizacao.dataHoraFim,'yyyy-MM-ddTHH:mm','en-US');
      this.editavelDataInicio = formatDate(this.eleicaoParametrizacao.dataHoraInicio,'yyyy-MM-ddTHH:mm','en-US');
      this.imageSrc = this.eleicaoParametrizacao.logo;
      this.formGroup.patchValue(this.eleicaoParametrizacao);
      this.formGroup.get("dataHoraFim").patchValue(this.editavelDataFim);
      this.formGroup.get("dataHoraInicio").patchValue(this.editavelDataInicio);
      this.gerarRota(); //chamando para na edição a rota já existente aparecer no link. Segue no change do input tbm.
    }
   ////
    this.spinner.hide();
  }

  public onSubmit(value){
    this.isSubmit = true;
    this.eleicao.dataHoraInicio = this.formGroup.get('dataHoraInicio').value;
    this.eleicao.dataHoraFim = this.formGroup.get('dataHoraFim').value;
    if (!this.formGroup.valid 
      || !this.validaData() 
      || !this.validaData(new Date(this.eleicao.dataHoraInicio)) 
      || !this.validaData(new Date(this.eleicao.dataHoraFim))) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Corrija o(s) erro(s) apontado(s) no formulário!" })
    }
    if(this.editandoEleicao == true){
      this.eleicao.labelAuth1 = this.formGroup.get('labelAuth1').value.trim();
      this.eleicao.labelAuth2 = this.formGroup.get('labelAuth2').value.trim();
    }
    this.eleicao.placeHolderLogin = this.formGroup.get('placeHolderLogin').value.trim();
    this.eleicao.titulo = this.formGroup.get('titulo').value.trim();
    this.eleicao.instrucao = this.formGroup.get('instrucao').value.trim();
    this.eleicao.termo = this.formGroup.get('termo').value.trim();
    this.eleicao.mensagem = this.formGroup.get('mensagem').value.trim();
    this.eleicao.rotaEleicao = this.rota;
    this.eleicao.statusEleicao = StatusEleicao.CRIADA.toString();
    this.eleicao.gestor = {id:this.idGestor};
    this.eleicao.logo = this.imageSrc;
    this.eleicao.acessoIntegracao = this.formGroup.get("acessoIntegracao").value;
    this.eleicao.enviaEmails = this.formGroup.get("enviaEmails").value;
    this.eleicao.rastreabilidade = this.formGroup.get("rastreabilidade").value;
    this.eleicao.id = this.eleicaoParametrizacao && this.eleicaoParametrizacao.id ? this.eleicaoParametrizacao.id : null;
    this.eleicao.temCandidaturas = this.formGroup.get("temCandidaturas").value;
    this.eleicao.temVotoEmBranco = this.formGroup.get("temVotoEmBranco").value;
    this.eleicao.temVotoNulo = this.formGroup.get("temVotoNulo").value;
    this.eleicao.temCancelarVoto = this.formGroup.get("temCancelarVoto").value;
    this.eleicao.temPlanos = this.formGroup.get("temPlanos").value;
    this.eleicao.cnpj = this.formGroup.get("cnpj").value.trim();
    this.token = sessionStorage.getItem('token');
    sessionStorage.setItem("eleicaoClicadaParametrizacao", JSON.stringify(this.eleicao)); // setando novos valores para a eleição do sessionStorage que está sendo editada;
    
    if(this.editandoEleicao == false) {
      this.btOff = true;      
      document.body.style.cursor = 'wait';
      this.eleicaoService.salvarDadosNovaEleicao(this.token,this.eleicao).then((data: Eleicao) => {
        this.resposta = data;
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Atenção', detail: "Eleição cadastrada com sucesso!" });
        setTimeout(function(){
          document.body.style.cursor = 'default';
          sessionStorage.removeItem("eleicaoClicadaParametrizacao");
          window.history.back();
        }, 1200)//redirect backwards da página pra depois do aviso 
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
        console.log("error",error);
        this.btOff = false;
        document.body.style.cursor = 'default';
      });
    } else {
      this.btOff = true;
      document.body.style.cursor = 'wait';
      this.eleicaoService.editarInfoEleicao(this.token, this.eleicao, this.eleicaoParametrizacao.id).then((data: Eleicao) => {
        this.resposta = data;
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Atenção', detail: "Eleição editada com sucesso!" });
        setTimeout(function(){
          document.body.style.cursor = 'default';          
          window.location.reload();          
        }, 1200)//nesse caso, necessário dar reload na página para mostrar ou esconder a tab de integração 
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
        console.log("error",error);
        this.btOff = false;
        document.body.style.cursor = 'default';
      });   
    }
  }

  public gerarRota() {
    var titulo = this.formGroup.get("titulo").value
    //Remove tudo que não for letra (caracter especial, pontuação, )
    this.rota = titulo.toLowerCase().normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z])|[" "]/g, '');
  }

  // valida se data inicio e data fim é superior a data atual
  public validaData(date?: Date){
    if ( date ) {
      var now = moment();
      return moment(date).isAfter(now) ? true : false;
    } else {
      var dataHoraInicio = this.formGroup.get('dataHoraInicio').value;
      var dataHoraFim = this.formGroup.get('dataHoraFim').value;
      if (dataHoraInicio && dataHoraFim) {
        return moment(dataHoraFim).isAfter(moment(dataHoraInicio)) ? true : false;
      }
      return false;
    }
  }

  public back(){
    //Impede o submit nessa função
    event.preventDefault();
    //============================

    window.history.back();
  }

  public imageSrc: string = '';

  handleInputChange(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e) {
    let reader = e.target;
    this.imageSrc = reader.result;
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: 'auto',
      minHeight: '0',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Insira as informações aqui',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
      customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage','insertHTML']
    ]
  };
  voltar(){
    sessionStorage.removeItem("eleicaoClicadaParametrizacao");
    this.location.back();
  }
  openFormModal() {
    this.formModal.show();
  }
  rastreabilidadeHabilitada() {
    this.formModal.hide();
    this.messageService.add({ key: 'toast', severity: 'success', summary: 'Atenção', 
    detail: this.formGroup.get("rastreabilidade").value =='true' ? 'Funcionalidade de rastreabilidade habilitada!' :'Funcionalidade de rastreabilidade desabilitada!'
  });   
  this.formGroup.get("rastreabilidade").patchValue(this.formGroup.get("rastreabilidade").value =='true' ? true:false);
  this.eleicaoParametrizacao.rastreabilidade = this.formGroup.get("rastreabilidade").value;
  }
  limpaRastreabilidade(){
  this.formModal.hide();
  this.formGroup.get("rastreabilidade").patchValue(this.eleicaoParametrizacao.rastreabilidade);
  }
  
}
